import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { endpoints } from 'environments/endpoints';
import { User } from '../../shared/models/actors-users/user.model';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';

@Injectable({
  providedIn: 'root'
})
export class ConnectedUserService {
  private baseRoute = environment.GATEWAY_API + endpoints.user.baseRoute;
  private subRoutes = endpoints.user.subRoutes;
  private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: User) {
    // Store the value
    this._user.next(value);
  }

  get user$(): Observable<User> {
    return this._user.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user
   *
   * @param user
   */
  update(user: User): Observable<any> {
    return this._httpClient.patch<User>('api/common/user', { user }).pipe(
      map(response => {
        this._user.next(response);
      })
    );
  }

  getUserByEmail(email: string): Observable<any> {
    return this._httpClient
      .get(
        `${this.baseRoute}${this.subRoutes.getByEmail}` + email,
        HttpHeadersUtil.prepareDefaultHeaders()
      )
      .pipe(map(res => res as any));
  }
}
